import type { SanityPageBuilderPartnersSection, SanityPageBuilderSection } from "@ouster/shared";
import { PartnersBlockView } from "~/features/blocks/inventory/partners";
import type { PartnerCardFragment, PartnersFiltersQuery } from "~/gql/graphql";

// `initialPartners` / `partnersFilters` are loaded server-side by the partners
// section loader (reference-section-loaders.server.ts) and embedded in
// sectionContent; they are not authored content, hence the local cast.
type PartnersSectionContent = SanityPageBuilderPartnersSection & {
  initialPartners?: PartnerCardFragment[];
  partnersFilters?: PartnersFiltersQuery;
};
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderPartnersSection;
  };
};
export function SanityPartnersSection({
  section
}: Props) {
  const {
    sectionSettings
  } = section;
  const content = section.sectionContent as PartnersSectionContent;
  const initialPartners = content.initialPartners ?? [];
  return <PartnersBlockView anchor={[{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }]} filters={content.partnersFilters ?? null} hasTopDivider={sectionSettings?.hasTopDivider ?? true} initialPartners={initialPartners} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} total={initialPartners.length} />;
}